import apiClient from './client';

export const fetchGenerationModels = () =>
  apiClient.get('/generation-models');

export default {
  fetchGenerationModels,
};
